'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.coverage_type', data.additional_data.coverage_type);
  (0, _commonFunctions.populateEligibility)(context, data);
}

function populateSchoolData(context, data) {
  context.updateProp('application.additional_data.school', data.additional_data.school);
  context.updateProp('application.additional_data.school_other', data.additional_data.school_other);
  context.updateProp('application.additional_data.school_board', data.additional_data.school_board);
  context.updateProp('application.additional_data.school_board_other', data.additional_data.school_board_other);
}

function populateApplicantsAdditionalData(context, data) {
  for (var i = 0; i < data.additional_data.additional_applicants_number + 1; i++) {
    context.updateProp('applicant[' + i + '].additional_data.school', data.additional_data.applicants[i].additional_data.school);
    context.updateProp('applicant[' + i + '].additional_data.school_other', data.additional_data.applicants[i].additional_data.school_other);
  }
}

function populateProductSpecificData(context, data) {
  populateCoverageData(context, data);
  populateSchoolData(context, data);
  populateApplicantsAdditionalData(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateProductSpecificData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student-accident/quote.js
// module id = 1759
// module chunks = 0